import { render, staticRenderFns } from "./CandidateApplicationForm.vue?vue&type=template&id=64d0bb2e&"
import script from "./CandidateApplicationForm.vue?vue&type=script&lang=js&"
export * from "./CandidateApplicationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports